/**
 * DevExtreme (ui/tooltip.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
module.exports = require("./tooltip/tooltip");
module.exports.show = require("./tooltip/ui.tooltip").show;
module.exports.hide = require("./tooltip/ui.tooltip").hide;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/ui/tooltip.js
// module id = ../../../../devextreme/ui/tooltip.js
// module chunks = 3